module.exports = __webpack_public_path__ + "static/SimeonA-5a5c490fec1fc6aa2450caaf17949053.gif";